module.exports = __webpack_public_path__ + "img/23rdandhare.9fe71a1a.jpg";